export const statusSearchOptions = [
    {
        value: "All", label: "All Active"
    },
    {
        value: "Draft", label: "Draft"
    },
    {
        value: "Scheduled", label: "Scheduled"
    },
    {
        value: "Progress", label: "Progress"
    },
    {
        value: "Completed", label: "Completed"
    },
    
];

export const statusOptionsObject = {

    "All" :  "All Active",

    "Draft" :  "Draft",

    "Scheduled" : "Scheduled",

    "Progress" : "Progress",

    "Completed" : "Completed",
   
};

export const workflowSearchOptions = [
    {
        value: "All", label: "All"
    },
    {
        value: "Active", label: "Active"
    },
    {
        value: "Inactive", label: "Inactive"
    }
];